// extracted by mini-css-extract-plugin
export default {"container":"Brand_container__onBL9","brand":"Brand_brand__yCFv7","notification":"Brand_notification__6ks2D"};